<template>
  <v-app class="overflow-x-hidden">
    <top-app-bar v-if="!isLoading && !isAuthRoute && isAuthenticated" />
    <v-main>
      <router-view />
    </v-main>
    <version-check />
    <invitations-poller v-if="isAuthenticated" />
  </v-app>
</template>

<script setup>
import { computed, nextTick, onBeforeMount, onMounted, ref, watch } from "vue";
import { useRouter, useRoute } from "vue-router";
import { authManager } from "@/services/authManager";
import { usePageTitleStore } from "@/store/pageTitle";
import authApi from "@/api/auth";
import TopAppBar from "@/components/TopAppBar.vue";
import authStore from "@/store/auth";
import VersionCheck from "@/components/ui/VersionCheck.vue";
import InvitationsPoller from "@/components/ui/InvitationsPoller.vue";
import { useDynamicRoutes } from "@/router/useDynamicRoutes";
import { ensureRoutesUpToDate } from "@/router";

const isAuthenticated = computed(() => authStore.isAuthenticated.value);
const router = useRouter();
const route = useRoute();
const pageTitleStore = usePageTitleStore();
const isLoading = ref(true);
const { availableRoutes } = useDynamicRoutes();

const AUTH_ROUTES = ["/login", "/register"];

const isAuthRoute = computed(() => {
  return AUTH_ROUTES.includes(router.currentRoute.value.path);
});

onBeforeMount(async () => {
  const initialRoute = router.options.history.location.split("?")[0];
  if (AUTH_ROUTES.includes(initialRoute)) {
    isLoading.value = false;
    return;
  }

  const matchedRoute = availableRoutes.value.find((route) => route.path === initialRoute);
  if (!matchedRoute?.meta?.public) {
    isLoading.value = true;
    const isValid = await authManager.validateSession();
    if (!isValid) {
      isLoading.value = false;
      return;
    }
    const { data, error } = await authApi.getProfile();
    if (error) {
      authStore.clear();
      router.replace("/login");
    } else {
      authStore.setAuthUser(data);
    }
    nextTick(() => {
      isLoading.value = false;
    });
  } else {
    isLoading.value = false;
  }
});

onMounted(() => {
  watch(route, () => {
    pageTitleStore.setRouteTitle(route.meta?.title);
  });

  watch(
    () => authStore.authChanged.value,
    async () => {
      await ensureRoutesUpToDate();
    },
  );
});
</script>
